'use client';

import {
  trackSubmitExperienceOpened,
  trackSubscribeClicked,
} from 'iq-interview_experiences/tracking';
import {PaywallModalContent} from 'iq-upselling/components/paywall_modal_content';
import {useSubscribeHref} from 'iq-upselling/hooks';

interface Props {
  onSignup: () => void;
  onShare: () => void;
}

const PRIMARY_CTA_CLASS =
  'w-full py-3 bg-iq-red text-white text-sm font-semibold rounded-lg hover:opacity-90 transition-opacity';
const SECONDARY_CTA_CLASS =
  'w-full px-6 py-2.5 border border-iq-grey-light text-iq-black text-sm font-semibold rounded-md hover:bg-iq-orange-light transition-colors';

// The locked-guide gate shown to anonymous visitors. Anonymous visitors get one
// partially-unlocked guide and are locked out from the second on, while a free account
// raises that to three — so signing up genuinely opens *this* guide. It does not add
// reports to a guide that is already partially unlocked, so the copy promises only the
// guide itself; sharing an experience is still what unlocks every report in it.
export function SignupUnlockGuideModalContent({onSignup, onShare}: Props) {
  const subscribeHref = useSubscribeHref();

  return (
    <PaywallModalContent
      title='Unlock this guide'
      description="You've already read your free guide. Create a free account to open this one, or share your own interview experience to unlock every candidate report in it right now."
      primaryAction={
        <button onClick={onSignup} className={PRIMARY_CTA_CLASS}>
          Sign up free
        </button>
      }
      secondaryAction={
        <>
          <button
            onClick={() => {
              void trackSubmitExperienceOpened('modal');
              onShare();
            }}
            className={SECONDARY_CTA_CLASS}>
            Share my interview experience
          </button>
          <a
            href={subscribeHref}
            onClick={() => void trackSubscribeClicked('modal')}
            className='self-center text-xs text-iq-grey-medium underline hover:text-iq-black transition-colors'>
            Subscribe to IQ Premium
          </a>
        </>
      }
    />
  );
}
